import axios from 'axios'

let counter = 0
const win: any = window
let errorPage = win['errorPageURL']

const createTransactionID: any = (isCorrelationId: boolean = false) => {
  let currentDateTime = new Date()
    .toISOString()
    .replace(/-|:|T/gi, '')
    .replace('.', '')
    .slice(2)
    .slice(0, -1)
  return (
    'POR' + (isCorrelationId ? 'C' : '') + currentDateTime + '_' + Math.ceil(Math.random() * 100000)
  )
}

function reGenerateToken() {
  console.log("reGenerateToken :: Enter");
  console.log("reGenerateTokenUrl => " + win['base_portal_url'] + "" + '/mobilyTheme4/UtilityServlet?tk=bm');

  return new Promise((resolve, reject) => {
    fetch(win['base_portal_url'] + "" + '/mobilyTheme4/UtilityServlet?tk=bm', {
      method: "GET",
      headers: {
        "Content-type": "text/html; charset=UTF-8",
      },
    })
      .then((res) => res.text())

      .then((result) => {
        resolve(result);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

let config = {
  api: {
    baseURL: '',
    headers: {
      'Content-Type': 'application/json',
      Authorization: '',
      'x-api-key': '',
      'X-Correlation-Id': createTransactionID(true),
      'X-Source-Channel': 'PORTAL',
      'X-Transaction-Id': '',
    },
  },
}

export const api = axios.create({ ...config.api })
export const simpleApi = axios.create()

api.interceptors.request.use(
  async (conf: any) => {
    conf.baseURL = win['apigee_bm_base_url']
    conf.headers.Authorization = `Bearer ${win['bmToken']}`
    conf.headers['x-api-key'] = win['apigee_bm_x_api_key']
    conf.headers['X-Transaction-Id'] = createTransactionID()
    return conf
  },
  err => {
    console.log('error in getting ', err)
  }
)

api.interceptors.response.use(
  async (response: any) => {
    if (
      (response.data.code && response.data.code === "APIGEE-001") ||
      (response.data.code && response.data.code === "APIGEE-002")
    ) {
      counter++;
      const token = await reGenerateToken();
      const { config: oldRequest } = response;
      oldRequest.headers.Authorization = `Bearer ${token}`;
      if (counter < 2) return api.request({ ...oldRequest });
    }

    return response;
  },
  async (error: any) => {
    console.log("404 error has", error.response, error.response.status, error.response.data);
    return error.response;
  }
);

const orderInquiryApi = (phoneNum: any, orderNum: any, hashCode: any) => {
  let data: any = {
    MobileNumber: phoneNum,
    OrderNumber: orderNum,
    OTPReferenceCode: hashCode,
  }
  return api.post(`/OrderGenerator/orderTracking/orderInquiry`, data);
  // return api.post('https://run.mocky.io/v3/889d3d12-aee0-4c2e-92f0-ec06a6641cd1'); //physical sim
  // return api.post(`https://run.mocky.io/v3/e3b8c0fd-b794-493d-9ded-1bbb410a2bfd`); //MNP esim
  // return api.post(`https://run.mocky.io/v3/d07d3d6a-6f98-4704-a1f6-a4a8cd170674`, data); //order not found
  // return api.post('https://run.mocky.io/v3/d787e745-7a3b-4f1a-a237-06958c8f4c76'); //multiple
  // return api.post('https://run.mocky.io/v3/09aa9a2e-86f8-4624-8411-41d9564100ee'); // new physical sim
  // return api.post('https://run.mocky.io/v3/6f51da57-0a92-4d71-9caf-e33da76d8975'); // new FTTH
  // return api.post('https://run.mocky.io/v3/3cd2807a-3a72-4b74-9b7d-ecfb2693394d'); // new MNP eSIM
  // return api.post('https://run.mocky.io/v3/a39a7628-ffc4-4328-bc97-7511401e71a8'); // new MNP Physical SIM
  // return api.post('https://run.mocky.io/v3/3b11c5c4-5ed2-4c61-b26c-db517c12bc6a'); // new multiple
  // return api.post('https://run.mocky.io/v3/c41255a7-5001-4ad9-80b0-80965cb27947'); // only 2 steps
  // return api.post('https://run.mocky.io/v3/a6182ad1-ef73-4023-b5be-a92549b46264');  //latest
  // return api.post('https://run.mocky.io/v3/1c456224-c2ec-479d-a5f8-047d0af525b3');  //latest multiple
}


const deliveryAddressChange = (
  orderNum: any,
  deliveryAddress: any,
  deliveryNotes: any,
  lat: any,
  lng: any,
  tookenId: any,
  otpRefCode: any
) => {
  let data: any = {
    OrderNumber: orderNum,
    DeliveryAddress: deliveryAddress,
    DeliveryNotes: deliveryNotes,
    Latitude: lat,
    Longitude: lng,
    TookanID: tookenId,
    OTPReferenceCode: otpRefCode,
  }
  return api.put(`/OrderGenerator/orderTracking/deliveryAddressChange`, data);
  // return api.post(`https://run.mocky.io/v3/8a57f64a-104b-4697-8eb2-62542ff1f1a9`)
}

const cancelTransferRequest = (orderId: any) => {
  let data: any = {
    orderId: orderId,
  }
  return api.post(`/OrderGenerator/cancelMNPOrder`,data);
  // return api.post('https://run.mocky.io/v3/9715f5b6-9804-4b8f-8f5b-200116a1ecc9')
}

const cTransferMockOrder = (phoneNum: any, orderNum: any, hashCode: any) => {
  let data: any = {
    MobileNumber: phoneNum,
    OrderNumber: orderNum,
    OTPReferenceCode: hashCode,
  }
  return api.post('https://run.mocky.io/v3/e5849bed-3e1a-461e-b847-bf1f71c75f23');
}

export {
  orderInquiryApi,
  deliveryAddressChange,
  cancelTransferRequest,
  cTransferMockOrder,
}
